import React, { MouseEvent, ReactNode } from 'react';
import Link from '@/providers/Link';
import { NavElement, NavList, NavListItem } from './SideNavMenu.styles';
import { Title } from '@/components/typography';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { useHoneyMoonContext } from '@/features/viagens/HoneyMoon/context';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';

const DestinationMapIcon = dynamic(() => import('../DestinationMapIcon/DestinationMapIcon'));

export interface SideNavMenuProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const SideNavMenu = ({ children, ...props }: SideNavMenuProps) => {
  const t = useTranslations('Viagem');
  const { data } = useHoneyMoonContext();
  const items: any[] | null = data.page.pacotes;

  if (!items) return null;

  let menu: { id: string; label: string; slug: string }[] = [];
  data.page.pacotes.forEach((item) => {
    menu.push({
      id: item.continent,
      label: item.continent,
      slug: item.continent.toLowerCase(),
    });
  });

  return (
    <WhitePaper>
      <Title as="h3" textCase="uppercase" color="secondary_500" size="lg">
        {t('Lua de Mel')} <span>{t('roteiros exclusivos')}</span>
      </Title>
      <NavElement>
        <NavList>
          {menu.map(({ id, label, slug }) => (
            <NavListItem key={id} active={slug === id}>
              <Link href={`#${slug}`}>
                <DestinationMapIcon id={label} width={32} />
                {label}
              </Link>
            </NavListItem>
          ))}
        </NavList>
      </NavElement>
    </WhitePaper>
  );
};

export default SideNavMenu;
